import React from 'react';
import { Card, CardContent, Typography } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles(theme => ({
  card: {
    backgroundColor: '#f0f9ff',
    border: '1px solid #bae6fd',
    borderRadius: theme.spacing(2),
    color: '#0369a1',
    textAlign: 'center',
    padding: theme.spacing(4),
  },
}));

interface EmptyStateProps {
  title: string;
  message: string;
}

export const EmptyState: React.FC<EmptyStateProps> = ({ title, message }) => {
  const classes = useStyles();
  return (
    <Card className={classes.card}>
      <CardContent>
        <Typography variant="h6" gutterBottom style={{ color: '#0369a1' }}>
          {title}
        </Typography>
        <Typography variant="body2" style={{ color: '#0369a1' }}>
          {message}
        </Typography>
      </CardContent>
    </Card>
  );
};
